import type { AppRoute } from 'src/routes/types';

import { JoinInner } from '@mui/icons-material';
import { t } from 'i18next';
import { lazy } from 'react';

const FosterFamilyAIMatchDetailView = lazy(
  () => import('./views/FosterFamilyAIMatchDetailView.tsx')
);
const FosterFamilyAIMatchListView = lazy(
  () => import('./views/FosterFamilyAIMatchListView.tsx')
);

export const aiRoutePaths = {
  fosterFamilyAIMatchDetail: '/ai/foster-family-ai-matches/:id',
  fosterFamilyAIMatchList: '/ai/foster-family-ai-matches',
} as const;

export const aiRoutes: AppRoute[] = [
  {
    element: <FosterFamilyAIMatchListView />,
    enabled: true,
    menu: {
      group: 'tools',
      icon: <JoinInner />,
      title: () => t('ai:AI_MATCHES'),
    },
    path: aiRoutePaths.fosterFamilyAIMatchList,
    permission: 'all',
    scope: 'private',
  },
  {
    element: <FosterFamilyAIMatchDetailView />,
    enabled: true,
    path: aiRoutePaths.fosterFamilyAIMatchDetail,
    permission: 'all',
    scope: 'private',
  },
];
